import MetaDataPanel from './MetaDataPanel';

export default MetaDataPanel;
